import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { api } from '../services/api';
import { toast } from 'sonner';
import { ArrowLeft, Mail, MailX, CheckCircle } from 'lucide-react';

export default function DesinscrirePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isUnsubscribed, setIsUnsubscribed] = useState(false);
  const prospectId = searchParams.get('id');

  const handleUnsubscribe = async () => {
    if (!prospectId) {
      toast.error('Lien invalide');
      return;
    }

    setIsLoading(true);
    try {
      await api.unsubscribeProspect(prospectId);
      setIsUnsubscribed(true);
      toast.success('Vous avez été désinscrit');
    } catch (error) {
      toast.error('Erreur lors de la désinscription');
    } finally {
      setIsLoading(false);
    }
  };

  if (!prospectId) {
    return (
      <div className="min-h-screen overflow-x-hidden overflow-y-auto flex items-center justify-center p-4"
        style={{ background: 'linear-gradient(135deg, #0a0015 0%, #1a0033 50%, #0a0015 100%)' }}
      >
        <div className="text-center">
          <p className="text-red-400 text-xl">❌ Lien invalide</p>
          <Button onClick={() => navigate('/')} className="mt-4">
            Retour à l'accueil
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen overflow-x-hidden overflow-y-auto flex flex-col items-center justify-center p-4"
      style={{ background: 'linear-gradient(135deg, #0a0015 0%, #1a0033 50%, #0a0015 100%)' }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <Button
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-4 text-cyan-400"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Accueil
        </Button>

        <div 
          className="backdrop-blur-xl rounded-3xl p-8 border-2 text-center"
          style={{
            background: 'rgba(10, 0, 30, 0.8)',
            borderColor: isUnsubscribed ? '#00FF00' : '#FF6B6B',
            boxShadow: `0 0 40px ${isUnsubscribed ? 'rgba(0, 255, 0, 0.3)' : 'rgba(255, 107, 107, 0.3)'}`
          }}
        >
          {isUnsubscribed ? (
            <>
              <CheckCircle className="w-16 h-16 mx-auto text-green-400 mb-4" />
              <h1 className="text-2xl font-bold text-white mb-2">
                Désinscription confirmée
              </h1>
              <p className="text-gray-400 mb-6">
                Vous ne recevrez plus d'emails promotionnels de La Petite Épicerie.
              </p>
              <p className="text-sm text-gray-500">
                Vous restez le bienvenu en boutique ! 😊
              </p>
            </>
          ) : (
            <>
              <MailX className="w-16 h-16 mx-auto text-red-400 mb-4" />
              <h1 className="text-2xl font-bold text-white mb-2">
                Se désinscrire
              </h1>
              <p className="text-gray-400 mb-6">
                Êtes-vous sûr de vouloir vous désinscrire de nos emails ?
              </p>
              <p className="text-sm text-gray-500 mb-6">
                Vous ne recevrez plus nos offres exclusives et promotions.
              </p>

              <div className="flex gap-3">
                <Button
                  onClick={() => navigate('/')}
                  variant="outline"
                  className="flex-1 border-gray-600 text-gray-400"
                >
                  Annuler
                </Button>
                <Button
                  onClick={handleUnsubscribe}
                  disabled={isLoading}
                  className="flex-1 bg-red-500 hover:bg-red-600"
                >
                  {isLoading ? (
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  ) : (
                    'Confirmer'
                  )}
                </Button>
              </div>
            </>
          )}
        </div>

        <p className="text-center text-gray-600 text-xs mt-4">
          La Petite Épicerie • 138 Rue Arthur Lamendin, 62980 Vermelles
        </p>
      </motion.div>
    </div>
  );
}
